import {openDialog} from 'vue3-promise-dialog';
import MsMessageBox from '@/components/messageBox/MsMessageBox.vue';

function getMsgOption(type, message, title, width, textBtn, textBtnClose, listBtn, customFocusBtn) {
  if (typeof message === 'object' && message.message) {
    return {...message, ...{type}};
  } else {
    return {
      type,
      message: message,
      title: title,
      width,
      textBtn,
      textBtnClose,
      listBtn,
      customFocusBtn,
    };
  }
}

function getMsgOptionCustom(type, message, title, customTextButton, width) {
  if (typeof message === 'object' && message.message) {
    return {...message, ...{type}};
  } else {
    return {type, message: message, title: title, customTextButton, width};
  }
}

export function showAlert(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(0, message, title, width));
}
export function showInfo(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(0, message, title, width));
}
export function showSuccess(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(0, message, title, width));
}
export function showError(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(0, message, title, width));
}
export function showConfirm(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(1, message, title, width));
}
export function showConfirmCancel(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(1, message, title, width));
}
export function showConfirmDelete(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(3, message, title, width));
}
export function showErrorCustom(message, title, type, width) {
  return openDialog(MsMessageBox, getMsgOption(type, message, title, width));
}
export function showConfirmValidate(message, title, customTextButton, width) {
  return openDialog(MsMessageBox, getMsgOptionCustom(5, message, title, customTextButton, width));
}
export function showConfirmValidateCustom(message, title, textBtn, width) {
  return openDialog(MsMessageBox, getMsgOption(6, message, title, width, textBtn));
}
export function showSyncDictionary(message, title, textBtn, width) {
  return openDialog(MsMessageBox, getMsgOption(10, message, title, width, textBtn));
}
export function showSyncParentChild(message, title, textBtn, width) {
  return openDialog(MsMessageBox, getMsgOption(11, message, title, width, textBtn));
}
export function showSyncDicRegular(message, title, textBtn, width) {
  return openDialog(MsMessageBox, getMsgOption(13, message, title, width, textBtn));
}

/**
 * Dialog show confirm khi lấy số bội chi
 * @param {*} message 
 * @param {*} title 
 * @param {*} customTextButton 
 * @param {*} width 
 * @returns 
 */
export function showConfirmLoanRepayment(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(111, message, title, width));
}


/**
 * Dialog show confirm với checkbox không hiển thị lại lần sau
 * TVDAT 05.07.2022
 */
export function showConfirmWithDontShowAgain(message, title, customLabelIsShowMessage, textBtn, width) {
  return openDialog(MsMessageBox, {
    type: 7,
    message,
    title,
    width,
    textBtn,
    customLabelIsShowMessage,
  });
}

export function showIncurredDataWarning(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(8, message, title, width));
}

// cảnh báo 2 button (dvhung2 17.04.2024)
export function showTwoButton(message, title, textBtn, width) {
  return openDialog(MsMessageBox, getMsgOption(12, message, title, width, textBtn));
}
export function showIsEnact(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(16, message, title, width));
}
export function showIsArise(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(3, message, title, width));
}

export function showConfirmCancelCustom(message, title, textBtn, width) {
  return openDialog(MsMessageBox, getMsgOption(15, message, title, width, textBtn));
}

export function showConfirmCustom(message, title, textBtn, width, textBtnClose) {
  return openDialog(MsMessageBox, getMsgOption(17, message, title, width, textBtn, textBtnClose));
}

export function showChooseOptionConfirm(message, optionList, title, width) {
  return openDialog(MsMessageBox, {
    type: 9,
    message: message,
    title: title,
    width,
    optionList,
    width: 500,
  });
}

export function showChooseOptionConfirmCustom(message, optionList, title) {
  return openDialog(MsMessageBox, {
    type: 20,
    message: message,
    title: title,
    optionList,
    width: 350,
  });
} //popup custom text của cả 2 nút-htthoa 17.9.2024
export function showConfirmDeleteCustom(message, title, textBtnCustom, textBtn, width) {
  return openDialog(MsMessageBox, {
    type: 21,
    message: message,
    title: title,
    width,
    textBtn: textBtn,
    width: 500,
    textBtnCustom: textBtnCustom,
  });
}

export function showConfirmWithMultipleButton(message, title, width, listBtn) {
  return openDialog(MsMessageBox, getMsgOption(22, message, title, width, null, null, listBtn));
}

export function showConfirmCustomClose(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(4, message, title, width));
}

export function showDialogCustom(MessageBox, param) {
  return openDialog(MessageBox, param);
}

export function showDialogWithParamCustom(param) {
  return openDialog(MsMessageBox, param);
}